import { stageOf, type PlaceId, type RoomId, type StageId } from '../ids';

// 장소 크기(px). 서버가 pos의 x·y 범위를 이 값으로 검사하고(server/2-controllers/core/player.ts), 화면의 장소(js/town.js PLACES)가 같은 값을 읽는다.
// 높이는 게임 화면 높이(G.H)와 같다. 마을 1440은 옛 js/town.js의 w. 건물 안은 화면 한 장(384)보다 넓은 곳이 있다
export const ROOM_H = 216;
export const ROOMS: Record<RoomId, { w: number; h: number }> = {
  town: { w: 1440, h: ROOM_H },
  school: { w: 512, h: ROOM_H },
  office: { w: 704, h: ROOM_H },
  starbox: { w: 384, h: ROOM_H },
};

// 모험 스테이지 크기(px) = 지도 칸 수 × 16. client/4-catalog/game/data.js의 지도와 같아야 한다(tools/check-world.mjs가 견준다). [가로 칸, 세로 칸]
const STAGE_TILES: Record<StageId, [number, number]> = {
  '1-1': [202, 16], '1-2': [180, 18], '1-3': [186, 16], '1-B': [24, 14], '2-1': [186, 22], '2-2': [192, 15], '2-3': [26, 52], '2-B': [24, 14], '3-1': [194, 16],
  '3-2': [190, 20], '3-3': [26, 64], '3-B': [24, 14], '4-1': [188, 20], '4-2': [196, 15], '4-3': [26, 60], '4-B': [24, 14], '5-1': [225, 18], '5-B': [24, 14],
};
export const STAGE_TILE = 16;
export const STAGE_SIZE = Object.fromEntries(Object.entries(STAGE_TILES).map(([id, [c, r]]) => [id, { w: c * STAGE_TILE, h: r * STAGE_TILE }])) as Record<StageId, { w: number; h: number }>;

// pos의 x·y가 가질 수 있는 범위. 장소는 0 ~ 크기, 스테이지는 벽 밖으로 조금(밀려 나감) 위쪽 · 아래쪽은 구덩이에 떨어지는 동안까지 여유를 둔다
const STAGE_PAD = { x: 32, up: 64, down: 192 };
export function placeBounds(place: PlaceId): { x0: number; x1: number; y0: number; y1: number } {
  const st = stageOf(place);
  if (!st) { const r = ROOMS[place as RoomId]; return { x0: 0, x1: r.w, y0: 0, y1: r.h }; }
  const s = STAGE_SIZE[st];
  return { x0: -STAGE_PAD.x, x1: s.w + STAGE_PAD.x, y0: -STAGE_PAD.up, y1: s.h + STAGE_PAD.down };
}
